var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0702 480.08H849.66V602.51L776.95 554.03L671.3 599.4L564.41 554.03L471.81 640.42L371.75 669.01L327.63 632.34L292.83 579.51L259.89 611.2L186.55 549.67L135.59 557.13L78.4102 508.03L4.4502 489.39L5.0702 480.07V480.08Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M703.46 491.69H652.09V628.95H703.46V491.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M652.48 473.15H703.18L703.07 492.22L652.42 502L652.47 473.15H652.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M660.94 500.4V519.08L694.83 511.77V493.75L660.94 500.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M671.38 516.88V568.19L677.81 558.25L683.8 562.53V514.25L671.38 516.89V516.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M652.41 629.01L663.49 629.44V691.46L672.02 695.08L672.87 693.59L683.1 694.02L684.17 694.87L690.99 691.89L691.63 690.61L692.25 629.2H703.1V773.13H652.46L652.41 629.02V629.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M652.28 629.4H660.98L661.06 691.91L677.75 696.32L694.86 690.52V629.37H703.15V773.26H652.36L652.28 629.41V629.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M652.32 501.99V773.24H703.13V492.15",
    fill: "#131F2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M652.32 501.99V773.24H703.13V492.15",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M661 518.97V739.8V518.97Z",
    fill: "#131F2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M661 518.97V739.8",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M694.78 511.77V739.52V511.77Z",
    fill: "#131F2E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M694.78 511.77V739.52",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M671.77 739.68V731H663.42V586.25H660.98",
    fill: "#131F2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M671.77 739.68V731H663.42V586.25H660.98",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M694.78 586.29H692.22V731.01H683.89V739.41",
    fill: "#131F2E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M694.78 586.29H692.22V731.01H683.89V739.41",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M677.97 575.48L682.68 580.19V629.32H684.26V641.68H671.34V629.25H673V582.12L677.97 575.49V575.48Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M671.94 643.71L664.56 650.27V691.87L671.61 694.88",
    fill: "#131F2E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M671.94 643.71L664.56 650.27V691.87L671.61 694.88",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M683.85 643.71L691.23 650.27V691.87L684.18 694.88",
    fill: "#131F2E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M683.85 643.71L691.23 650.27V691.87L684.18 694.88",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M671.98 674.23L664.52 676.68L671.98 674.23Z",
    fill: "#131F2E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M671.98 674.23L664.52 676.68",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M683.81 674.23L691.27 676.68L683.81 674.23Z",
    fill: "#131F2E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M683.81 674.23L691.27 676.68",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M663.47 718.95H672.02H663.47Z",
    fill: "#131F2E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M663.47 718.95H672.02",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M683.47 718.95H692.02H683.47Z",
    fill: "#131F2E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M683.47 718.95H692.02",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M683.85 724.46C683.85 727.77 681.17 730.45 677.86 730.45C674.55 730.45 671.87 727.77 671.87 724.46C671.87 721.15 674.55 718.47 677.86 718.47C681.17 718.47 683.85 721.15 683.85 724.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M683.89 689.68C683.89 692.99 681.21 695.67 677.9 695.67C674.59 695.67 671.91 692.99 671.91 689.68C671.91 686.37 674.59 683.69 677.9 683.69C681.21 683.69 683.89 686.37 683.89 689.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M652.35 739.11L604.12 744.54L652.35 748.16V739.12V739.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M652.35 758.4L604.12 763.83L652.35 767.45V758.41V758.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M703.29 758.4L751.52 763.83L703.29 767.45V758.41V758.4Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M703.29 739.11L751.52 744.54L703.29 748.16V739.12V739.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M652.5 472.96H649.94V475.67H652.5V472.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M671.79 472.96H669.23V475.67H671.79V472.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M686.56 472.96H684V475.67H686.56V472.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M706.3 472.96H703.74V475.67H706.3V472.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M706.45 460.6H703.89V463.31H706.45V460.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M686.71 460.6H684.15V463.31H686.71V460.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M671.79 460.45H669.23V463.16H671.79V460.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M652.65 460.75H650.09V463.46H652.65V460.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M660.94 463.01V447.49H694.7V463.31L660.94 463.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M648.8 463.16L648.91 472.94H706.7V463.16H648.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M648.75 468.1L706.81 468.21L648.75 468.1Z",
    fill: "#131F2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M648.75 468.1L706.81 468.21",
    stroke: "#F7F9F9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M723.43 430.71V427.14H727.75V430.71H723.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M695.83 429.57H705.53L706.92 432.02H719.71V430.74H731.65L732.13 432.82H745.61L741.83 440.28H732.24L730.91 441.77H720.31L719.3 440.49H706.51V443.9H695.96L695.85 429.57H695.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M658.6 447.59L695.91 447.64V425.79H658.68L658.6 447.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M667.53 425.71H664.97V428.42H667.53V425.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M663.37 417.18H660.81V419.89H663.37V417.18Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M695.98 417.03H693.42V419.74H695.98V417.03Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M690.6 425.55H688.04V428.26H690.6V425.55Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M657.3 419.5V426.05H698.38V419.5H657.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M657.41 422.64H698.33H657.41Z",
    fill: "#131F2E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M657.41 422.64H698.33",
    stroke: "#F7F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M706.86 431.91C706.86 431.91 705.58 435.91 706.65 440.6L706.86 431.91Z",
    fill: "#131F2E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M706.86 431.91C706.86 431.91 705.58 435.91 706.65 440.6",
    stroke: "#F7F9F9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M719.59 431.96C719.59 431.96 718.74 435.26 719.59 440.65V431.96Z",
    fill: "#131F2E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M719.59 431.96C719.59 431.96 718.74 435.26 719.59 440.65",
    stroke: "#F7F9F9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M732.17 432.98C732.17 432.98 731.32 436.28 732.22 440.17L732.17 432.98Z",
    fill: "#131F2E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M732.17 432.98C732.17 432.98 731.32 436.28 732.22 440.17",
    stroke: "#F7F9F9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M731.16 422.16C731.16 425.25 728.66 427.76 725.58 427.76C722.49 427.76 719.98 425.26 719.97 422.18V422.16C719.97 419.07 722.47 416.56 725.56 416.56C728.65 416.56 731.16 419.06 731.16 422.15V422.17V422.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M720.77 424.69L722.21 424.08L720.77 424.69Z",
    fill: "#131F2E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M720.77 424.69L722.21 424.08",
    stroke: "#F7F9F9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M720.08 422.67L721.55 422.59L720.08 422.67Z",
    fill: "#131F2E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M720.08 422.67L721.55 422.59",
    stroke: "#F7F9F9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M720.37 420.35L721.68 420.8L720.37 420.35Z",
    fill: "#131F2E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M720.37 420.35L721.68 420.8",
    stroke: "#F7F9F9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M721.6 418.3L722.59 419.26L721.6 418.3Z",
    fill: "#131F2E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M721.6 418.3L722.59 419.26",
    stroke: "#F7F9F9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M725.52 423.14L721.89 418.86L723.03 417.94L726.45 422.27L725.51 423.15L725.52 423.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M723.35 416.99L723.91 418.27L723.35 416.99Z",
    fill: "#131F2E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M723.35 416.99L723.91 418.27",
    stroke: "#F7F9F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M726.52 422.21C726.52 422.7 726.13 423.09 725.65 423.1C725.16 423.1 724.77 422.71 724.76 422.23C724.76 421.73 725.15 421.34 725.63 421.33C726.12 421.33 726.51 421.72 726.52 422.2V422.21Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M725.62 416.6L725.59 417.99L725.62 416.6Z",
    fill: "#131F2E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M725.62 416.6L725.59 417.99",
    stroke: "#F7F9F9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M730.48 424.69L729.04 424.08L730.48 424.69Z",
    fill: "#131F2E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M730.48 424.69L729.04 424.08",
    stroke: "#F7F9F9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M731.17 422.67L729.7 422.59L731.17 422.67Z",
    fill: "#131F2E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M731.17 422.67L729.7 422.59",
    stroke: "#F7F9F9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M730.88 420.35L729.57 420.8L730.88 420.35Z",
    fill: "#131F2E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M730.88 420.35L729.57 420.8",
    stroke: "#F7F9F9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M729.66 418.3L728.67 419.26L729.66 418.3Z",
    fill: "#131F2E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M729.66 418.3L728.67 419.26",
    stroke: "#F7F9F9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M727.9 416.99L727.34 418.27L727.9 416.99Z",
    fill: "#131F2E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M727.9 416.99L727.34 418.27",
    stroke: "#F7F9F9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M731.16 422.16C731.16 425.25 728.66 427.76 725.58 427.76C722.49 427.76 719.98 425.26 719.97 422.18V422.16C719.97 419.07 722.47 416.56 725.56 416.56C728.65 416.56 731.16 419.06 731.16 422.15V422.17V422.16Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M430.9 424.76V390.33L494.86 342.61H500.88L512.08 352.27L507.74 399.86L501.3 401.96L481.15 425.61L430.91 424.77L430.9 424.76Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M515.08 349.75L515.78 347.79C516.13 346.9 517.23 346.02 518.51 345.13L529.78 345.06C530.72 345.68 530.98 346.75 531.39 347.72L529.08 349.68L515.09 349.75H515.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M503.05 398.52L501.93 393.83L503.12 357.93C506.71 353.9 510.68 350.35 515.58 347.99L549.03 347.78L548.75 365.06L539.51 390.04L530.41 400.26L503.19 399.91L503.05 398.51V398.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M574.07 398.87L562.73 385.15L577.74 386.06L577.63 390.89L576.55 392.29V399.29L574.07 398.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M498.22 444.36V399.44L499.48 398.18H578.69L579.11 402.38L580.09 402.12V408.96L498.21 444.37L498.22 444.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M335.43 190.82H644H335.43Z",
    fill: "#131F2E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.43 190.82H644",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M639.96 167.79L346.39 167.32L334.89 190H643.92L639.96 167.78V167.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M653.86 100.13L637.7 163.21L657.28 275.7C659.99 279.42 662.85 280.07 665.36 279.89C679.53 223.39 680.45 160.7 665.05 109.14L653.86 100.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M339.24 189.85V185.97H516.21V190.01",
    fill: "#131F2E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M339.24 189.85V185.97H516.21V190.01",
    stroke: "#F7F9F9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M335.33 190.01H344.93C344.93 190.01 344.98 190.03 344.98 190.06V200.21C344.98 200.21 344.96 200.26 344.93 200.26H335.33C335.33 200.26 335.28 200.24 335.28 200.21V190.06C335.28 190.06 335.3 190.01 335.33 190.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M560.85 431.23H544.03V464.68H560.85V431.23Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M361.54 209.66L610.5 396.45L619.16 392.56L366.52 202.04L361.55 209.65L361.54 209.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M351.05 214.64L418.79 463L428.73 462.84L359.59 212.46L351.04 214.64H351.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M347.32 197.54L346.85 201.5L350.04 216.03L362.39 212.77L369.69 203.21L357.11 194.74L353.07 194.27L347.32 197.53V197.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M353.07 194.63C353.07 196.71 351.38 198.4 349.3 198.4C347.22 198.4 345.53 196.71 345.53 194.63C345.53 192.55 347.22 190.86 349.3 190.86C351.38 190.86 353.07 192.55 353.07 194.63Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M629.74 401.54H613.11V465.27H629.74V401.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M615.68 465.28V401.75V465.28Z",
    fill: "#131F2E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M615.68 465.28V401.75",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M488.56 382.85L488.84 434.28C488.62 440.13 487.23 444 485.76 447.72",
    fill: "#131F2E"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M488.56 382.85L488.84 434.28C488.62 440.13 487.23 444 485.76 447.72",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M456.65 465.63V458.63L622.9 388.82L629.04 403.07L479.81 466.01L456.66 465.63H456.65Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M608.36 373.87L555.6 358.61L539.08 363.23C537.4 364.33 537.14 365.58 537.12 366.87L536.98 393.32L556.71 386.88L608.63 389.4L608.35 373.87H608.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M605 383.11L608.04 365.62L611.01 364.36L617.45 364.43L620.32 365.97L622.77 383.22L604.99 383.12L605 383.11Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M606.82 211.39H609.2V191.8L618.51 192.01V211.53H620.96C619.9 212.95 618.47 214.07 616.48 214.75H611.65C609.26 214.07 607.91 212.81 606.82 211.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M611.02 196.9C611.02 198.06 610.08 199 608.92 199C607.76 199 606.82 198.06 606.82 196.9C606.82 195.74 607.76 194.8 608.92 194.8C610.08 194.8 611.02 195.74 611.02 196.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M620.75 196.9C620.75 198.06 619.81 199 618.65 199C617.49 199 616.55 198.06 616.55 196.9C616.55 195.74 617.49 194.8 618.65 194.8C619.81 194.8 620.75 195.74 620.75 196.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M611.44 204.11L611.86 349.31H616.55V204.11H611.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M610.32 205.3L617.53 205.23L617.46 194.38C615.31 192.34 612.96 191.88 610.25 194.31L610.32 205.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M604.99 191.04H622.66C622.66 191.04 622.71 191.06 622.71 191.09V193.08C622.71 193.08 622.69 193.13 622.66 193.13H604.99C604.99 193.13 604.94 193.11 604.94 193.08V191.09C604.94 191.09 604.96 191.04 604.99 191.04Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M606.89 196.9H620.68H606.89Z",
    fill: "#131F2E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M606.89 196.9H620.68",
    stroke: "#F7F9F9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M612.98 346.16C611.44 346.4 610.75 347.21 610.32 348.19V372.19H618.16V348.33C617.52 346.64 616.51 346.4 615.5 346.16H612.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M622.92 383.81C622.92 388.76 618.92 392.77 613.97 392.78C609.02 392.78 605.01 388.78 605 383.83V383.81C605 378.86 609 374.85 613.95 374.84C618.9 374.83 622.91 378.84 622.92 383.79V383.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M618.93 383.88C618.93 386.55 616.77 388.71 614.1 388.71C611.43 388.71 609.27 386.55 609.27 383.88C609.27 381.21 611.43 379.05 614.1 379.05C616.77 379.05 618.93 381.21 618.93 383.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M605.56 381.82L606.12 378.53L608.78 375.22L614.66 373.38L619.54 375.44L621.86 378.87L622.39 381.88L614.66 376.25L605.56 381.81V381.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M557.42 374.15C557.42 376.78 555.3 378.91 552.67 378.91C550.04 378.91 547.91 376.79 547.9 374.16C547.9 371.52 550.02 369.38 552.65 369.38C555.28 369.38 557.41 371.5 557.41 374.13L557.42 374.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M570.01 362.54L566.65 387.17L570.01 362.54Z",
    fill: "#131F2E"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M570.01 362.54L566.65 387.17",
    stroke: "#F7F9F9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M591.43 388.57L594.3 369.61L591.43 388.57Z",
    fill: "#131F2E"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M591.43 388.57L594.3 369.61",
    stroke: "#F7F9F9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M523.43 361.87H534.24C534.24 361.87 534.29 361.89 534.29 361.92V384.77C534.29 384.77 534.27 384.82 534.24 384.82H523.43C523.43 384.82 523.38 384.8 523.38 384.77V361.92C523.38 361.92 523.4 361.87 523.43 361.87Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M524.25 373.54C524.25 381.97 517.44 388.8 509.01 388.81C500.59 388.81 493.75 382 493.74 373.57V373.54C493.74 365.11 500.55 358.28 508.98 358.27C517.4 358.27 524.24 365.08 524.25 373.51V373.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M522.47 366.52L526.07 369.6V376.67L522.08 380.83",
    fill: "#131F2E"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M522.47 366.52L526.07 369.6V376.67L522.08 380.83",
    stroke: "#F7F9F9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M521.85 373.26C521.85 380.36 516.1 386.12 509 386.13C501.9 386.13 496.14 380.38 496.13 373.28V373.26C496.13 366.16 501.88 360.4 508.98 360.4C516.08 360.4 521.84 366.15 521.85 373.25V373.27V373.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M537.16 371.46H531.98H537.16Z",
    fill: "#131F2E"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M537.16 371.46H531.98",
    stroke: "#F7F9F9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M527.82 373.8L527.33 372.4C527.42 370.47 527.72 368.64 527.3 366.45C526.52 363.8 524.07 360.13 521.42 359.03H519.36C517.7 358.34 517.42 357.2 516.81 356.16C516.74 355.57 516.53 355.17 516.81 354.06C517.11 352.69 518.12 352.04 518.94 351.19C525.95 354.99 532.51 359.39 532.83 372.08L527.97 373.62L527.83 373.79L527.82 373.8Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M511.65 373.82C511.65 375.37 510.4 376.62 508.86 376.62C507.31 376.62 506.06 375.37 506.06 373.83C506.06 372.27 507.31 371.02 508.85 371.02C510.4 371.02 511.65 372.27 511.65 373.81V373.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M510.67 371.44C510.67 372.37 509.92 373.12 509 373.12C508.07 373.12 507.32 372.37 507.32 371.45C507.32 370.51 508.07 369.76 508.99 369.76C509.92 369.76 510.67 370.51 510.67 371.43V371.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M533.14 373.66C533.14 375.19 531.9 376.42 530.38 376.42C528.86 376.42 527.62 375.18 527.62 373.66C527.62 372.14 528.86 370.9 530.38 370.9C531.9 370.9 533.14 372.14 533.14 373.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M532.54 375.17L537.02 375.1L532.54 375.17Z",
    fill: "#131F2E"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M532.54 375.17L537.02 375.1",
    stroke: "#F7F9F9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M498.36 402.09H579.53H498.36Z",
    fill: "#131F2E"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M498.36 402.09H579.53",
    stroke: "#F7F9F9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M489.82 382.85L487.37 382.92L487.02 382.01L486.81 379.14L486.11 378.23L486.18 374.45H489.47V376.9L489.82 379.49V382.85Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M486.6 375.22L485.06 374.66L484.78 372.21L485.55 371.51L488.49 371.65L488.77 372.7L488.7 374.8L487.09 375.22H486.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M486.32 372.56L485.97 370.04L484.15 368.78L484.64 367.31L487.65 367.66V372.84L486.32 372.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M486.46 366.96H490.87V364.44L486.32 364.51L486.46 366.96Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M487.37 366.47C487.37 367.51 486.53 368.36 485.49 368.37C484.45 368.37 483.6 367.53 483.59 366.49C483.59 365.44 484.43 364.59 485.47 364.58C486.51 364.58 487.36 365.42 487.37 366.46C487.37 366.46 487.37 366.46 487.37 366.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M489.89 364.44L489.96 363.46H493.32V367.1H490.52L489.89 364.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M493.18 359.54L491.71 359.05L491.78 358.14L493.81 357.86L494.02 357.16L495.77 357.09L495.98 359.19L495.21 359.61L495.35 367.73V380.61H493.6V381.87H491.99L491.78 379.98L484.71 379.7L484.36 379.21L484.29 377.88L484.78 377.25H491.57V367.1L492.76 363.18L493.18 359.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M452.93 423.97V406.04H476.86V424.06L452.93 423.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.98
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M435.83 400.17H444.84L454.93 423.88L435.63 423.84L435.82 400.18L435.83 400.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.89
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M437.66 422.82H435.76V424.15H437.66V422.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M444.75 422H454.36L454.41 423.97H444.78L444.75 422Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M444.97 422.66H443.07V423.99H444.97V422.66Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M442.76 420.86H437.98V423.2H442.76V420.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M442.09 419.05H438.8V420.63H442.09V419.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M470.91 406.08V421.2H476.81V405.99L470.91 406.08Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M471.02 422.82H469.12V424.15H471.02V422.82Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M478.32 422.81H476.42V424.14H478.32V422.81Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M476.11 420.86H471.33V423.2H476.11V420.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M475.45 419.05H472.16V420.63H475.45V419.05Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M435.82 405.22L436.07 393.62L451.92 382.75L451.83 405.49L435.82 405.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.89
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M435.81 398.84L452.85 398.62L452.94 400.5L435.77 400.19L435.81 398.85V398.84Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 0.89
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M471.14 407.44C471.14 415.87 464.12 422.7 455.46 422.7C446.8 422.7 439.78 415.87 439.78 407.44C439.78 399.01 446.8 392.18 455.46 392.18C464.12 392.18 471.14 399.01 471.14 407.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M468.56 407.42C468.56 414.45 462.7 420.15 455.48 420.15C448.26 420.15 442.4 414.45 442.4 407.42C442.4 400.39 448.26 394.69 455.48 394.69C462.71 394.69 468.56 400.39 468.56 407.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M456.54 398C456.54 398.61 456.03 399.11 455.4 399.11C454.77 399.11 454.26 398.62 454.26 398C454.26 397.38 454.77 396.89 455.4 396.89C456.03 396.89 456.54 397.38 456.54 398Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M456.54 416.88C456.54 417.49 456.03 417.99 455.4 417.99C454.77 417.99 454.26 417.49 454.26 416.88C454.26 416.27 454.77 415.77 455.4 415.77C456.03 415.77 456.54 416.27 456.54 416.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M446.84 407.44C446.84 408.05 446.33 408.55 445.7 408.55C445.07 408.55 444.56 408.06 444.56 407.44C444.56 406.82 445.07 406.33 445.7 406.33C446.33 406.33 446.84 406.82 446.84 407.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M466.39 407.44C466.39 408.05 465.88 408.55 465.25 408.55C464.62 408.55 464.11 408.06 464.11 407.44C464.11 406.82 464.62 406.33 465.25 406.33C465.88 406.33 466.39 406.82 466.39 407.44Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M448.32 428.34H450.25C451.01 428.34 451.63 428.96 451.63 429.72V463.02C451.63 463.78 451.01 464.4 450.25 464.4H448.32C447.56 464.4 446.94 463.78 446.94 463.02V429.72C446.94 428.96 447.56 428.34 448.32 428.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.54
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M428.73 424.71H496.22C496.95 424.71 497.53 425.3 497.53 426.02V428.15C497.53 428.88 496.94 429.46 496.22 429.46H428.73C428 429.46 427.42 428.87 427.42 428.15V426.02C427.42 425.29 428.01 424.71 428.73 424.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M440.44 420.51V427.97V420.51Z",
    fill: "#131F2E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M440.44 420.51V427.97",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M473.8 420.51V427.97V420.51Z",
    fill: "#131F2E"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M473.8 420.51V427.97",
    stroke: "#F7F9F9",
    strokeWidth: 0.59
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M495.3 342.27C488.63 335.58 482.67 328.64 472.07 323.38C468.39 321.9 465.54 322.07 462.97 322.82C461.57 323.95 460.17 325.13 458.77 327.72C447.23 354.31 447.71 356.66 447.99 364.11C448.48 370.39 449.59 373.82 451.21 376.01",
    fill: "#131F2E"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M495.3 342.27C488.63 335.58 482.67 328.64 472.07 323.38C468.39 321.9 465.54 322.07 462.97 322.82C461.57 323.95 460.17 325.13 458.77 327.72C447.23 354.31 447.71 356.66 447.99 364.11C448.48 370.39 449.59 373.82 451.21 376.01",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M468.29 429.18C468.14 431.14 467.71 433.1 468.99 435.06C472.26 440.08 476.67 444.34 481.03 448.64",
    fill: "#131F2E"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M468.29 429.18C468.14 431.14 467.71 433.1 468.99 435.06C472.26 440.08 476.67 444.34 481.03 448.64",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M486.9 375.3L486.55 374.18L486.16 371.52L486.89 371.42L488.43 371.66L488.6 374.14L489.4 374.53L489.3 375.26L486.89 375.29L486.9 375.3Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M335.57 458.35H347.25L349.13 460.38L351.21 460.28L352.79 458.7H378.07L379.36 460.53L377.23 460.58H376.04V459.39H374.75V460.63H373.56V459.34H372.32V460.63H371.13V459.44H369.94V460.58H368.75V459.39H367.51V460.58H366.37V459.34H365.23V460.58H358.01V462.26H384.33V461.12L385 460.45H400.02V462.3H409.47V463.54H334.71L335.55 458.34L335.57 458.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M327.06 462.61V459.25C327.33 458.58 327.51 457.86 328.54 457.57L335.66 457.47L335.46 462.52L327.05 462.62L327.06 462.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M335.82 461.36H325.92V464.73H335.82V461.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M332.55 457.6H329.58V464.92H332.55V457.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M629.73 463.69H330.27V479.92H629.73V463.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M329.88 476.36L629.74 476.16L329.88 476.36Z",
    fill: "#131F2E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M329.88 476.36L629.74 476.16",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M314.83 464.13L313.34 462.25L316.71 459.68L322.75 459.78L326.11 459.88L326.21 465.32L314.83 464.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M310.72 467.39L314.94 463.47H330.46L330.31 480.95L323.98 468.59L321.27 468.44L320.82 478.84L319.31 480.65L310.72 467.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M322.57 453.13V438.74L319.63 441.3V453.81L322.57 453.13Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M322.13 471.49H319.57V475.17H317.01V428.01H319.73L319.52 468.29H322.18L322.13 471.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M317.12 441.12C317.07 441.55 320.16 440.96 320.16 440.96C320.16 440.96 322.88 439.2 323.3 437.18C323.37 436.19 324.2 436.89 323.51 434.2C323.62 433.72 322.12 433.19 322.12 433.19C322.12 433.19 321.91 434.95 320.1 437.45C320.1 437.45 318.34 439.16 316 439.58C316 439.58 315.57 440.81 317.12 441.13V441.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M316.91 453.26H322.13L322.08 455.61H317.07L316.91 453.26Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M317.03 458.42L319.37 458.31V463.32H317.03V458.42Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M353.78 459.98C353.78 462.06 352.1 463.74 350.02 463.75C347.94 463.75 346.26 462.07 346.25 459.99C346.25 457.9 347.93 456.21 350.01 456.21C352.09 456.21 353.77 457.89 353.78 459.97V459.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M396.31 459.79C396.31 461.66 394.8 463.19 392.92 463.19C391.05 463.19 389.52 461.68 389.52 459.8C389.52 457.91 391.03 456.39 392.91 456.39C394.78 456.39 396.31 457.9 396.31 459.78V459.79Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M347.9 456L350.12 455.5L351.09 459.27L348.87 459.76L347.9 456Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M390.83 456.22L393.05 455.73L394.02 459.49L391.79 459.99L390.83 456.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M669.99 419.75V399.63H666.49V395.71H686.38V399.74H682.57V419.75H669.99Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M676.58 395.72V207.01V395.72Z",
    fill: "#131F2E"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M676.58 395.72V207.01",
    stroke: "#F7F9F9",
    strokeWidth: 3
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M107.52 266.86H102.25V322.47H107.52V266.86Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5699 324.12H73.1699V327.89H94.5699V324.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8398 385.39C92.9498 392.32 101.69 392.1 104.1 385.54L105.23 381.17",
    fill: "#131F2E"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8398 385.39C92.9498 392.32 101.69 392.1 104.1 385.54L105.23 381.17",
    stroke: "#F7F9F9",
    strokeWidth: 2
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M77.27 478.98H90.76L90.84 384.18L77.28 384.03V478.98H77.27Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9198 479.13L87.7498 384.18H77.2798V479.05L87.9298 479.13H87.9198Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.08
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4498 380.94H73.2798V384.41H94.4498V380.94Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M110.09 327.14H59.2998V381.55H110.09V327.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M107.83 330.6H61.5596V378.07H107.83V330.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2196 369.7C74.2196 373.06 71.6196 375.79 68.4196 375.79C65.2196 375.79 62.6196 373.07 62.6196 369.7C62.6196 366.33 65.2196 363.61 68.4196 363.61C71.6196 363.61 74.2196 366.33 74.2196 369.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2797 369.72C86.2797 373.1 83.6797 375.83 80.4797 375.83C77.2797 375.83 74.6797 373.09 74.6797 369.72C74.6797 366.35 77.2797 363.61 80.4797 363.61C83.6797 363.61 86.2797 366.35 86.2797 369.72Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3397 369.68C98.3397 373.03 95.7397 375.75 92.5397 375.75C89.3397 375.75 86.7397 373.03 86.7397 369.68C86.7397 366.33 89.3397 363.61 92.5397 363.61C95.7397 363.61 98.3397 366.33 98.3397 369.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9798 369.64C71.9798 371.48 70.4898 372.98 68.6398 372.98C66.7898 372.98 65.2998 371.49 65.2998 369.64C65.2998 367.79 66.7898 366.3 68.6398 366.3C70.4798 366.3 71.9798 367.79 71.9798 369.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0399 369.64C84.0399 371.48 82.5499 372.98 80.6999 372.98C78.8499 372.98 77.3599 371.49 77.3599 369.64C77.3599 367.79 78.8499 366.3 80.6999 366.3C82.5399 366.3 84.0399 367.79 84.0399 369.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0999 369.64C96.0999 371.48 94.6099 372.98 92.7599 372.98C90.9099 372.98 89.4199 371.49 89.4199 369.64C89.4199 367.79 90.9099 366.3 92.7599 366.3C94.5999 366.3 96.0999 367.79 96.0999 369.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2696 334.22H105.87C106.54 334.22 107.08 334.76 107.08 335.43V360.15C107.08 360.82 106.54 361.36 105.87 361.36H64.2696C63.5996 361.36 63.0596 360.82 63.0596 360.15V335.43C63.0596 334.76 63.5996 334.22 64.2696 334.22Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M105.42 337.09H65.0298V359.09H105.42V337.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 322.17H109.04C109.71 322.17 110.25 322.71 110.25 323.38V325.79C110.25 326.46 109.71 327 109.04 327H101.5C100.83 327 100.29 326.46 100.29 325.79V323.38C100.29 322.71 100.83 322.17 101.5 322.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M103.01 259.47H107.53C108.86 259.47 109.94 260.55 109.94 261.88V265.04C109.94 266.37 108.86 267.45 107.53 267.45H103.01C101.68 267.45 100.6 266.37 100.6 265.04V261.88C100.6 260.55 101.68 259.47 103.01 259.47Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M100.6 262.94H72.8696",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2798 248.47V276.8",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3599 250.96V274.47",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4097 254.01V271.56",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5596 257.66V269.23",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9497 260.07V265.76",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6899 261.28V264.75",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark2);
export default __webpack_public_path__ + "static/media/mark-2.e8adaa4d5fbb2786877c05d7b6bd6636.svg";
export { ForwardRef as ReactComponent };